module.exports = __webpack_public_path__ + "static/media/jangba.ad1a76ad.jpg";